module.exports = __webpack_public_path__ + "static/media/image-7.da046ef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/top-home-search/image-7.png
// module id = 2203
// module chunks = 0